import axiosInstance from './axiosInstance';
import { formatDate } from '../utils/helpers';

const getPayments = (filters = {}) => {
  const {
    perPage,
    page,
    column,
    orderColumn,
    email,
    service,
    from,
    to,
  } = filters;

  return axiosInstance.get('/internal/admin/payments', {
    params: {
      per_page: perPage,
      page,
      column: column ?? 'created_at',
      order_column: orderColumn ?? 'DESC',
      email,
      service,
      payed_from: from ? formatDate(from, 'MM/DD/YYYY hh:mm A') : null,
      payed_to: to ? formatDate(to, 'MM/DD/YYYY hh:mm A') : null,
    },
  });
};

export default getPayments;
